// export default CountryWrapper;
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "../components/common/Loader";

const CountryWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { country } = useParams();
  const [isChecking, setIsChecking] = useState(true);
  const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

  useEffect(() => {
    const validateCountryAccess = async () => {

      if (isLocalhost) {
      console.warn("Localhost detected — skipping country validation");
      setIsChecking(false);
      return;
    }


    try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}admin/client-ip`
        );
        
        console.log("Country API Response:", res.data);

        if (!res.data?.allowed) {
          console.log("Access denied by API");
          navigate("/country-blocked", { replace: true });
          return;
        }

        const detectedCountry = res.data.country?.toLowerCase();

        if (location.pathname === "/") {
          if (detectedCountry) {
            navigate(`/${detectedCountry}`, { replace: true });
          } else {
            navigate("/country-blocked", { replace: true });
          }
          return;
        }

        if (country) {
          if (country.toLowerCase() !== detectedCountry) {
            console.warn(
              `Country mismatch: URL has "${country}" but user is from "${detectedCountry}"`
            );
            
            const remainingPath = location.pathname.replace(`/${country}`, '');
            navigate(`/${detectedCountry}${remainingPath}`, { replace: true });
            
            // Option B: Block them completely (uncomment if you want strict blocking)
            // navigate("/country-blocked", { replace: true });
            return;
          }
        }

        setIsChecking(false);
        
      } catch (error) {
        console.error("Country validation failed:", error);
        navigate("/country-blocked", { replace: true });
      }
    };

    validateCountryAccess();
  }, [location.pathname, country, navigate]);

  if (isChecking) {
    return <Loader isClass="loader_fullscreen" />;
  }

  return <Outlet />;
};

export default CountryWrapper;